<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        @if(this.TypeData === 'PF'){
        Upload PF No. Master
        }@else if(this.TypeData === 'UAN'){
        Upload UAN No. Master
        }@else if(this.TypeData === 'ESIC'){
        Upload ESIC No. Master
        }@else if(this.TypeData === 'LIN'){
        Upload LIN No. Master
        }
    </div>
    <form name="IDCardReport" (ngSubmit)="Validate(IDCardReport)" #IDCardReport="ngForm" class="pb-2" novalidate>
        <div class="card-body">
            <div class="row d-flex">
                <div class="col-md-6 px-1">
                    <label class="form-font-label">Branch</label>
                    <ng-select name="Branchmaster" id="Branchmaster" [items]="BranchMaster" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Filter.BranchID" #Branchmaster="ngModel"
                        placeholder="Select Branch" (change)="ComboLoad2('Reports EmpMaster')">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch!
                    </div>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-md-3 px-1">
                    <label class="form-font-label">Emp Code</label>
                    <ng-select name="Employeemaster" id="Employeemaster" [items]="EmployeeMaster" bindLabel="Code"
                        bindValue="ID" [(ngModel)]="Filter.EmpMasterID" #Employeemaster="ngModel"
                        placeholder="Select Employee Code">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Employee!
                    </div>
                </div>
                <div class="col-md-6 px-1"><br>
                    <input type="text" class="form-control" placeholder="" disabled>
                </div>
                <div class="col-md-3 px-1 d-flex align-items-end">
                    <button type="submit" name="submit1" class="btn btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Search' : 'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="isDisabled" class="loading-spinner">
            <p>Loading...</p>
        </div>
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Employee List
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">SrNo</th>
                                <th scope="col" style="width: 8px;">Emp Code</th>
                                <th scope="col">Employee Name</th>
                                <th scope="col" style="width: 45px;">PF/ESIC/LIN/UAN No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let shift of TableData; let i = index">
                                <th scope="row">{{ shift['SrNo'] }}</th>
                                <td>{{ shift['EmpCode']}}</td>
                                <td>{{ shift['Name']}}</td>
                                <td style="width: 45px;">
                                    <!-- {{ shift['Column1']}} -->
                                    <input type="text" [(ngModel)]="shift['Column1']" class="form-control" name="{{i}}">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
                <label for="file-upload" class="btn btn-sm btn-primary">
                    <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                </label>
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                    accept=".xls,.xlsx">
                <button type="button" name="Print" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>